import { Injectable } from '@angular/core';
import { DropdownService, IDropdownData } from '@captiveaire/advanceddropdown';
import { IQuery } from '@captiveaire/query';
import { IGridPagedResult } from '../../src/typings/IGridPagedResult';
import { ProxyService } from '../proxy/ProxyService';
import { ICustomerService } from './ICustomerService';

@Injectable({
    providedIn: 'root'
})
export class CustomerService implements ICustomerService {
    public static $name: string = 'customerService';

    constructor(
        private dropdownService: DropdownService,
        private proxyService: ProxyService
    ) {
    }

    public getCustomers() {
        return this.proxyService.request({
            endPoint: this.getEndpointName(),
            route: 'getCustomers'
        }).asArray<CASLink.Infrastructure.Ui.ViewModel.Location.CustomerViewModel>();
    }

    public getList(query: IQuery):
        angular.IPromise<IGridPagedResult<CASLink.Infrastructure.Ui.ViewModel.Location.CustomerViewModel>> {

        const items = this.getCustomers().then(result => {
            result.splice(0, 0, { description: 'None', id: 0 });

            return {
                items: result,
                totalCount: result.length
            };
        });
        return items;
    }

    public getEndpointName() {
        return 'customer';
    }

    public getListItem(id: number): angular.IPromise<IGridPagedResult<CASLink.Infrastructure.Ui.ViewModel.Location.CustomerViewModel>> {
        return this.getList(null).then(result => {
            const item = result.items === undefined ? undefined : result.items.find(item => item.id === id);
            return {
                items: [item],
                totalCount: item === undefined ? 0 : 1
            };
        });
    }

    public prepareDropdown(customerId: number): IDropdownData {
        const dropdown = this.dropdownService.prepareDropdown(
            'Customer', // Uppercase rather than getEndpointName(), since this is used for the dropdown label
            'description',
            this,
            customerId
        );

        dropdown.titleHandler = (item: CASLink.Infrastructure.Ui.ViewModel.Location.CustomerViewModel) => {
            return item.description;
        };

        dropdown.getList().finally(() => {
            dropdown.visible = dropdown.totalCount > 0;
        });

        return dropdown;
    }

    // Check whether the user has access to view the customers dropdown.
    public getCanFilterByCustomer(): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: this.getEndpointName(),
            route: 'getCanFilterByCustomer'
        }).as<boolean>();
    }
}
